<template>
	<div class="individual-personal-details">
		<AssessmentCharacteristics
			:high-type="highType"
			:characteristics="( user.location || `` )"
			:is-skeleton="false"
			:auto-skeleton="false"
		>
			<template #icon>
				<FontAwesomeIcon
					:icon="['fad', 'head-side-brain']"
				/>
			</template>
			<template #heading>{{ translate( "locationHeading" ) }}</template>
		</AssessmentCharacteristics>
		<AssessmentCharacteristics
			:high-type="highType"
			:characteristics="( user.bio || `` )"
			:is-skeleton="false"
			:auto-skeleton="false"
		>
			<template #icon>
				<FontAwesomeIcon
					:icon="['fad', 'head-side-brain']"
				/>
			</template>
			<template #heading>{{ translate( "bioHeading" ) }}</template>
		</AssessmentCharacteristics>
	</div>
</template>

<script>
import {
	TranslateMixin,
	AssessmentCharacteristics
} from "@teaming/common-ui";

export default {
	name: "IndividualPersonalDetails",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	components: {
		AssessmentCharacteristics,
	},
	props: {
		assessment: {
			type: Object,
			required: true,
		},
		user: {
			type: Object,
			required: true,
		},
	},
	computed: {
		highType() {
			if ( !this.assessment ) {
				return "X";
			}
			return this.assessment.moniker[ 0 ].toUpperCase();
		},
	},
};
</script>

<style lang="scss" scoped>

.individual-personal-details {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}
</style>
